/**
 * Precheck: information about the site before anything renders.
 * @module precheck
 */

/** Whether pre-rendered data exists in Mastodon's format. */
const hasPrerenderMastodon = Boolean(document.getElementById("initial-state"));

/** Whether initial data was loaded into the page by server-side-rendering (SSR). */
export const isPrerendered = hasPrerenderMastodon;
